import { LeftOutlined } from '@ant-design/icons';
import { Button, Menu } from 'antd';

export type MenuItem<NameType> = {
  name: NameType;
  disabled?: boolean;
};

export type MenuCustomProps<NameType> = {
  menuItems: MenuItem<NameType>[];
  selectedMenu: MenuItem<NameType>;
  setSelectedMenu: (menuItem: MenuItem<NameType>) => void;
};
export const MenuCustom = <NameType extends string | number>({
  menuItems,
  selectedMenu,
  setSelectedMenu,
}: MenuCustomProps<NameType>) => {
  const selectedIndex = menuItems.findIndex(
    (item) => item.name === selectedMenu.name
  );

  return (
    <Menu
      mode="horizontal"
      onClick={({ key }) => {
        setSelectedMenu(menuItems[+key]);
      }}
      selectedKeys={[selectedIndex.toString()]}
      overflowedIndicator={
        <Button>
          <LeftOutlined />
        </Button>
      }
      items={menuItems.map((item, index) => ({
        key: index.toString(),
        disabled: item.disabled,
        label: item.name,
      }))}
    />
  );
};
